// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"cfe9edc5","796":"cbac8f54"}[chunkId] + ".chunk.js";
};